export default {"src":"/_next/static/media/backyard.e3b34e87.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};